import React, { useContext, useEffect, useState } from 'react'
import LawFirmProfilePage from './LawFirmProfilePage';
import ClientDetails from './ClientDetails';
import ClientDetailsEdit from './ClientDetailsEdit';
import { Context } from '../../Context/Context';
import CompleteLawFirmProfile from './CompleteLawFirmProfile';
import ProfessionalDetailsEdit from './ProfessionalDetailsEdit';
import ProfessionalDetails from './ProfessionalDetails';
import {PROFESSIONAL, CLIENT, FIRM} from '../../Constants';
import LitigationFunderProfile from './LitigationFunderProfile';
import LitigationFunderProfileDetails from './LitigationFunderProfileDetails';

function EditProfile({setActivePanel}) {
  const [showEdit, setShowEdit] = useState(false);
  const {userDetails, setUpdateLoggedinData} = useContext(Context);
  const role = userDetails?.role;


  useEffect(() => {
    setUpdateLoggedinData(prev => !prev);
  }, [])

  return (showEdit ? 
    ( 
      role === CLIENT ? <ClientDetailsEdit setShowEdit={setShowEdit}/> 
      : 
      role === PROFESSIONAL ? 
      (userDetails?.isUserFunder  ? 
        <>
        <LitigationFunderProfile setShowEdit={setShowEdit} showConsent={false}/>
        </>
        :
        <div className='w-full px-2 lg:px-10 '>
        <ProfessionalDetailsEdit setShowEdit={setShowEdit}/> 
      </div>
      )
      : (
      role === FIRM ? <CompleteLawFirmProfile setShowEdit={setShowEdit}
      noSteps={userDetails?.verified ? true : false}
      /> : <></>)  
    )
    :
    ( 
      role === CLIENT ? <ClientDetails setShowEdit={setShowEdit}/>
      : 
      role === PROFESSIONAL ?
      (
        userDetails?.isUserFunder  ?
        <LitigationFunderProfileDetails setShowEdit={setShowEdit} />
        :
     
      <ProfessionalDetails setShowEdit={setShowEdit} setActivePanel={setActivePanel}/> )
      : (role === FIRM ?
      <LawFirmProfilePage setShowEdit={setShowEdit} /> 
      : <></>)
      )
    )
}

export default EditProfile;